import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

type AppRedirectTarget = "/" | "/login" | "/change-password";

export function AppRedirect({ to }: { to: AppRedirectTarget }) {
  const navigate = useNavigate();

  useEffect(() => {
    void navigate({ to, replace: true });
  }, [navigate, to]);

  return null;
}
